import { render, staticRenderFns } from "./DialogAudit.vue?vue&type=template&id=e20e576c&scoped=true&"
import script from "./DialogAudit.vue?vue&type=script&lang=js&"
export * from "./DialogAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20e576c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e20e576c')) {
      api.createRecord('e20e576c', component.options)
    } else {
      api.reload('e20e576c', component.options)
    }
    module.hot.accept("./DialogAudit.vue?vue&type=template&id=e20e576c&scoped=true&", function () {
      api.rerender('e20e576c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/components/DialogAudit.vue"
export default component.exports